(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/cart-item
 * -----------------------------------------------------------------------------
 * @version 0.0.5
 * @overview Cart line item progressive enhancements.
 * @copyright 2022 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("cart-item") === undefined) {
    class CartItem extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.cartItemKey = this.dataset.cartItemKey;
            if (!this.cartItemKey) return;
            this.quantityInput = this.querySelector('[name="updates[]"]');
            this.statusMessage = this.querySelector('[role="status"]');
            this.currentQuantity = this.quantityInput?.valueAsNumber;
            this.quantityInput?.addEventListener("change", this.debounce(this.quantityUpdateEvent.bind(this), 1000));
        }
        debounce(callback, timeout) {
            let timer;
            return (...args)=>{
                clearTimeout(timer);
                timer = setTimeout(()=>callback.apply(this, args), timeout);
            };
        }
        quantityUpdateEvent(event) {
            this.updateQuantity(event.target.value);
        }
        updateQuantity(itemQuantity) {
            this.loadingState(true);
            if (this.statusMessage) this.statusMessage.hidden = true;
            this.fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/javascript"
                }
            };
            this.fetchOptions.headers["X-Requested-With"] = "XMLHttpRequest";
            this.fetchOptions.body = JSON.stringify({
                id: this.cartItemKey,
                quantity: itemQuantity
            });
            fetch(`${routes.cart_change_url}`, this.fetchOptions).then((response)=>response.text()).then((response)=>{
                response = JSON.parse(response);
                const cartItem = response.items.find((obj)=>obj.key === this.cartItemKey);
                if (cartItem && cartItem.quantity === this.currentQuantity) {
                    this.currentQuantity = cartItem.quantity;
                    this.quantityInput.value = this.currentQuantity;
                    this.quantityError();
                    return;
                }
                if (cartItem) this.quantityInput.focus();
                const type = cartItem ? "updated" : "removed";
                const quantity = cartItem ? cartItem.quantity : 0;
                document.dispatchEvent(new CustomEvent("cart:updated", {
                    detail: {
                        type: type,
                        items: [
                            {
                                key: this.cartItemKey,
                                quantity: quantity
                            }
                        ]
                    }
                }));
                this.loadingState(false);
            }).catch((error)=>this.errorHandler(error));
        }
        quantityError() {
            if (this.statusMessage) this.statusMessage.hidden = false;
            this.loadingState(false);
        }
        errorHandler(error) {
            // TODO: General error handler
            console.error("An error has occured", error);
            this.loadingState(false);
        }
        loadingState(loading) {
            if (loading) {
                this.style.pointerEvents = "none";
                this.classList.add("loading");
                document.activeElement.blur();
            // TODO: Accessibility item loading message
            // if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
            } else {
                this.style.pointerEvents = null;
                this.classList.remove("loading");
                this.quantityInput?.focus();
            }
        }
    }
    customElements.define("cart-item", CartItem);
}



})();
